<template>
  <div class="autocomplete-input-container" :class="{ focus: isFocused, error: isError }">
    <div v-if="label" class="label">{{ label }}</div>
    <vue-simple-suggest class="autocomplete-input" v-model="selected" :list="options" :filter-by-query="true"
                        :max-suggestions="5" @focus="setFocused" @blur="setBlurred">
      <text-input :placeholder="placeholder" :value="selected" :error="isError"
                  :propagate-events="true" Type="'string'" :inputPattern="'\\s*'"/>
    </vue-simple-suggest>
    <div v-if="isError" class="error-message">{{ errorMessage }}</div>
  </div>
</template>

<script>
import VueSimpleSuggest from 'vue-simple-suggest';
import TextInput from './TextInput';

export default {
  name: 'AutocompleteInput',
  components: {
    TextInput,
    VueSimpleSuggest,
  },
  props: {
    placeholder: {
      type: String,
      require: false,
      default: '',
    },
    options: {
      type: Array,
      require: true,
    },
    onSelect: {
      type: Function,
      require: true,
    },
    startValue: {
      type: String,
      required: false,
      default: '',
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    errorMessage: {
      type: String,
      required: false,
      default: 'צריך לבחור אפשרות מהרשימה',
    },
  },
  data() {
    return {
      selected: this.startValue,
      isFocused: false,
    };
  },
  computed: {
    isValueValid() {
      return this.selected === '' || this.options.includes(this.selected);
    },
    isError() {
      return !this.isFocused && !this.isValueValid;
    },
  },
  methods: {
    setFocused() {
      this.isFocused = true;
    },
    setBlurred() {
      this.isFocused = false;
    },
  },
  watch: {
    startValue(newValue) {
      // Sometimes, this component is created before data is properly loaded. So the prop "startValue" starts empty,
      // and then this.selected is started empty as well. We want to "restart" the component when "startValue" becomes available.
      if (!this.selected) {
        this.selected = newValue;
      }
    },
    selected(newValue) {
      this.$emit('change', newValue);
    },
  },
};
</script>

<style lang="scss">
@import '../../scss/riseup-colors';
@import '../../scss/riseup-z-index';
@import '../../scss/border-radius';

.autocomplete-input-container {
  .label {
    color: $riseup_black;
    font-size: 14px;
    margin-bottom: 8px;
  }
  .autocomplete-input {
    position: relative;
    .input-group {
      margin: 0;
    }
    // this doesn't have a special class
    div[aria-expanded='true'] {
      .input {
        border-radius: $ri-border-radius-small $ri-border-radius-small 0 0;
        border: solid 1px $riseup_blue;
      }
    }
    .suggestions {
      padding: 0px;
      position: absolute;
      width: 100%;
      background-color: $riseup_white;
      border-radius: 0 0 $input-field-border-radius $input-field-border-radius;
      border: solid 1px $riseup_blue;
      border-top: none;
      z-index: $input-suggestion-drop-menu;
      .suggest-item {
        padding: 0px 10px;
        font-size: 20px;
        line-height: 36px;
        color: $riseup_black;
        list-style-type: none;
        &:hover {
          background-color: $riseup_gray_0;
        }
      }
    }
  }
  .error-message {
    color: $riseup_danger_red;
    font-size: 14px;
    margin-top: 8px;
  }
}

.autocomplete-input-container.focus {
  .label {
    color: $riseup_blue;
  }
}

.autocomplete-input-container.error {
  .label {
    color: $riseup_danger_red;
  }
}

</style>
